import { batchGenFn } from '@/api/request'

const genPostFn = batchGenFn()

export const getSmsCaptcha = genPostFn('/auth/user/sendValidateCode')
export const register = genPostFn('/auth/account/register')
export const createTrialApplication = genPostFn('/target/metaCare/trialApplication/create')
